/**
 * Les gestes qu'on mesure sur le site, et la question à laquelle chacun répond.
 *
 * La vitrine ne vend rien directement : elle amène vers l'app ou vers le
 * comptoir. Les seuls gestes qui valent la peine d'être comptés sont donc
 * ceux qui disent une INTENTION, pas ceux qui disent une lecture.
 *
 * Nom en clair, en français, comme le reste du code : c'est Michel qui les
 * relit dans PostHog, pas un analyste.
 */
export const EVENEMENT = {
  /** Clic sur un badge de boutique. Qui va réellement chercher l'app. */
  APP_STORE_CLIC: "app_store_clic",

  /**
   * Quelqu'un réclame un pays qu'on ne sert pas.
   *
   * Le plus précieux des six : la Search Console montre des impressions
   * venues du Sénégal, qui n'est pas desservi. Cet événement dit quels pays
   * ouvrir, avec des noms et des chiffres au lieu d'une intuition.
   */
  PAYS_DEMANDE: "pays_demande",

  // Rien pour le simulateur de prix : le composant `home/Estimator.tsx`
  // existe mais n'est monté nulle part. Instrumenter du code mort donne un
  // événement qui ne se déclenche jamais, et on finit par croire que
  // personne ne simule de prix. Le jour où il revient dans une page, il
  // méritera son événement.

  /** Une page corridor a été ouverte. Quelle route intéresse vraiment. */
  CORRIDOR_VU: "corridor_vu",

  /** Un commerce dépose sa candidature de partenaire. */
  CANDIDATURE_PARTENAIRE: "candidature_partenaire",

  /** Une entreprise demande à être rappelée (page pro). */
  RAPPEL_DEMANDE: "rappel_demande",
} as const;
